module.exports = __webpack_public_path__ + "static/media/image2.3516bf50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Restaurant/images/image2.jpg
// module id = 371
// module chunks = 0